/**
 * Serialize the currently-filtered audit rows to a CSV string (CT-4212).
 *
 * Client-side export of the fetched/mock rows — all table columns plus the
 * before/after state of each change. No PII is placed in URLs; the caller wraps
 * this in a Blob download. TODO(CT-3904): server-side export for large ranges.
 *
 * @param {object[]} rows — audit events (the current filtered page/result set).
 * @returns {string} CSV text (header row + one row per event).
 */
export function auditToCsv(rows) {
  const header = [
    'timestamp',
    'severity',
    'code',
    'provider',
    'instance',
    'actor',
    'actor_id',
    'actor_ip',
    'studio',
    'before',
    'after',
  ];
  // Wrap every cell in quotes; prefix a leading =/+/-/@ with an apostrophe so
  // spreadsheet apps don't interpret an actor name or detail as a formula.
  const escape = (value) => {
    const s = String(value ?? '');
    const safe = /^[=+\-@]/.test(s) ? `'${s}` : s;
    return `"${safe.replace(/"/g, '""')}"`;
  };
  const stringify = (value) =>
    value == null ? '' : typeof value === 'object' ? JSON.stringify(value) : String(value);

  const lines = (rows ?? []).map((row) =>
    [
      row.timestamp,
      row.severity,
      row.code ?? row.event,
      row.provider_name,
      row.instance_name,
      row.actor?.name,
      row.actor?.id,
      row.actor?.ip ?? row.ip,
      row.studio,
      stringify(row.before),
      stringify(row.after),
    ]
      .map(escape)
      .join(','),
  );

  return [header.join(','), ...lines].join('\n');
}
